import {InjectionToken} from '@angular/core';
import {IStackPanelConfig} from './interface';

export const STACK_PANEL_CONFIG = new InjectionToken<IStackPanelConfig>('STACK_PANEL_CONFIG');
